import React, { useRef } from 'react';
import { Toaster } from 'react-hot-toast';
import { Hero } from './Hero';
import { PricingSection } from './pricing/PricingSection';
import { ContactSection } from './ContactSection';
import { Footer } from './Footer';
import { scrollToElement } from '../utils/scroll';

const LandingPage: React.FC = () => {
  const contactRef = useRef<HTMLDivElement>(null);

  const handleGetStarted = () => {
    if (contactRef.current) {
      scrollToElement(contactRef.current);
    }
  };

  const navigateToWebsites = () => {
    window.history.pushState({}, '', '/websites');
    window.location.reload();
  };

  const navigateToEmails = () => {
    window.history.pushState({}, '', '/emails');
    window.location.reload();
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 to-blue-900 text-white p-8">
      <Toaster position="top-center" />
      
      {/* Navigation */}
      <nav className="max-w-6xl mx-auto mb-8">
        <div className="flex justify-end gap-6">
          <button
            onClick={navigateToEmails}
            className="text-yellow-400 hover:text-yellow-300 transition-colors font-medium"
          >
            Email Dashboard →
          </button>
          <button
            onClick={navigateToWebsites}
            className="text-yellow-400 hover:text-yellow-300 transition-colors font-medium"
          >
            AI-Powered Websites →
          </button>
        </div>
      </nav>

      <div className="max-w-6xl mx-auto space-y-24 py-12">
        <Hero />
        <PricingSection onGetStarted={handleGetStarted} />
        <div ref={contactRef}>
          <ContactSection />
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default LandingPage;